import dayjs from "dayjs";

let interval;
export default {
  initEventStartTimer({ state, commit, getters }) {
    if (!state.eventStartTimerInterval) {
      interval = setInterval(() => {
        let millisecondsToEvent = getters.eventStartDate.diff(dayjs());
        commit("setMillisecondsToEvent", millisecondsToEvent);

        if (!state.eventStartTimerInterval) {
          commit("setEventStartTimerInterval", null);
        }
      }, 1000);
      commit("setEventStartTimerInterval", interval);
    }
  },
  clearEventStartTimer() {
    clearInterval(interval);
  }
};
